import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="container py-3">
      {/* Header Section */}
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold">
          SmartLend Nigeria
          <div className="text-primary">Fintech + Solar Loan Platform</div>
        </h1>

        <p className="lead mt-3">
          Get instant access to cash loans and solar financing with SmartLend Nigeria. <br />
          Apply now with just your BVN.
        </p>
        <div className="d-flex justify-content-center mt-4 gap-3 flex-wrap">
          <Link to="/loan-application" className="btn btn-dark btn-lg">
            Apply for Loan
          </Link>
          <Link to="/register" className="btn btn-outline-primary btn-lg">
            Register
          </Link>
        </div>
      </div>

      {/* Features Section */}
      <div className="row text-center g-4">
        {/* Cash Loans */}
        <div className="col-md-4">
          <h5 className="text-uppercase fs-3 fw-bold" style={{ color: '#192A81' }}>Cash Loans</h5>
          <h3 className="fw-bold">Quick & Secure Financing</h3>
          <p className="text-muted">
            Get access to cash loans from ₦10,000 to ₦100,000 <br /> with flexible repayment options.
          </p>
          <Link to="/loan-application" className="btn btn-outline-primary btn-sm py-3 fw-bold">
            Apply for Cash Loan
          </Link>
        </div>

        {/* Solar Loans */}
        <div className="col-md-4">
          <h5 className="text-uppercase text-primary fs-3 fw-bold">Solar Loans</h5>
          <h3 className="fw-bold">Clean Energy Financing</h3>
          <p className="text-muted">
            Finance DABEEL solar kits <br /> with flexible repayment options over 6 months.
          </p>
          <Link to="/loan-application" className="btn btn-outline-primary btn-sm py-3 fs-6 fw-bold">
            Apply for Solar Loan
          </Link>
        </div>

        {/* Easy Process */}
        <div className="col-md-4">
          <h5 className="text-uppercase fs-3 fw-bold" style={{ color: '#192A81' }}>Easy Process</h5>
          <h3 className="fw-bold">Simple & Secure</h3>
          <p className="text-muted">
            Apply in minutes with just your BVN and NIN. <br /> Get instant approval.
          </p>
          <Link to="/register" className="btn btn-outline-primary btn-sm py-3 fw-bold">
            Get Started
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
